import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';

export const roleUrl = `${SERVER_API}/role`;

export const ADMINISTRATION_ROLE = {
  ...generateCrudEndpoints(`${roleUrl}`),
  CREATE: {
    method: 'POST',
    url: `${roleUrl}`,
  } as IEndpointData,
  PERMISSIONS: {
    method: 'GET',
    url: `${roleUrl}/permissions`,
  } as IEndpointData,
  HISTORY(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${roleUrl}/${id}/history`,
    };
  },
};
